<h2 mat-dialog-title>Informe o e-mail para envio</h2>
<mat-dialog-content>
  <p class="mt-3">Qual e-mail deseja receber o relatório do extrato de consumo?</p>
  <mat-form-field class="w-100 mt-2">
    <mat-label>E-mail</mat-label>
    <input matInput [(ngModel)]="email" type="mail" >
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancelar</button>
  <button mat-button [mat-dialog-close]="email" cdkFocusInitial>Confirmar</button>
</mat-dialog-actions>
